import { createAction } from '@reduxjs/toolkit'

import { Segment } from 'common/filter/interfaces'
import { mapResponse } from 'shared/api/lib/mapResponse'
import { AudienceApi } from 'shared/api/requests/audience'
import { createListSlice } from 'shared/lib/factory/redux/createListSlice'
import { createListOperations } from 'shared/lib/factory/redux/createListSlice/lib/createListOperations'

interface UpdateCounterPayload {
  id: Segment['segment_id']
  delta: number
}

export const updateCounter = createAction<UpdateCounterPayload>('segments/updateCounter')

export const segmentsSlice = createListSlice({
  storePath: 'segments',

  namespace: 'segments',

  operations: createListOperations({
    getList: mapResponse(AudienceApi.fetchSegments, (response) => response.data.segments),
    getNextList: undefined,
    getPrevList: undefined,
    createItem: undefined,
    deleteItem: undefined,
    updateItem: undefined,
  }),

  getItemId: (item: Segment) => item.segment_id,

  extraState: {},

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(updateCounter, (state, action) => {
      const { id, delta } = action.payload
      const segment = state.byId[id]
      if (segment) {
        segment.count = Number(segment.count) + delta
      }
    })
  },
})

export type SegmentsState = ReturnType<typeof segmentsSlice.reducer>
